import { Chip, SxProps, Theme } from '@mui/material';
import React from 'react';

interface PillProps {
  label?: string;
  sx?: SxProps<Theme>;
  children?: React.ReactNode;
  onDelete?: (_event: React.SyntheticEvent) => void;
  onClick?: (_event: React.SyntheticEvent) => void;
}

const Pill: React.FC<PillProps> = ({ label, sx = {}, children, onDelete, onClick }) => (
  <Chip
    label={label || children}
    onDelete={onDelete}
    onClick={onClick}
    sx={{
      borderRadius: (theme) => `${theme.borderRadius.md}px`,
      fontWeight: 500,
      fontSize: '14px',
      background: (theme) => theme.palette.pill.background,
      color: (theme) => theme.palette.pill.text,
      height: 36,
      ...sx,
    }}
  />
);

export default Pill;
